<template>
  <div class="body-wrapper">
    <div class="checkmark-circle">
      <img class="tick" src="@/assets/images/crossCircleRed.svg">
    </div>

    <span class="success-title">
      Adım Başarısız
    </span>

    <span class="success-description">
      {{ questionData?.name || 'No description available.' }}
    </span>
  </div>
</template>

<script>
export default{
  props:{
    questionData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.body-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  width: 100%;
  height: 100%;
  background-color: #ed5f50;
}

.success-title {
  font-size: 20px;
  line-height: 20px;
  font-family: euclid_bold, sans-serif;
  color: #FFFFFF;
  margin-top: 10px;
}

.success-description {
  font-size: 14px;
  line-height: 14px;
  font-family: euclid_regular, sans-serif;
  max-width: 80%;
  text-align: center;
  color: #FFFFFF;
}

.tick {
  width: 80px;
  height: 80px;
}

.checkmark-circle {
  position: relative;
  width: 80px;
  height: 80px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
